import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackTransportAccessibilityEntryClick, trackTransportAccessibilityEntryShown } from './tracking';
import { useOpenTransportAccessibility } from './useOpenTransportAccessibility';
import { TransportAccessibilityEntry } from '../../components/TransportAccessibilityEntry';
import { getTransportAccessibility } from '../../selectors/newbuilding';
import { prepareRate } from '../../utils/transportAccessibility';

export const TransportAccessibilityEntryContainer: React.FC = () => {
  const transportAccessibilityRate = useSelector(getTransportAccessibility);
  const openTransportAccessibility = useOpenTransportAccessibility();

  const handleClick: React.MouseEventHandler<HTMLElement> = React.useCallback(
    event => {
      openTransportAccessibility();

      scrollToAnchor({
        anchor: '#infrastructure',
        offset: 0,
        hasRelocation: false,
        hasAnimation: true,
      })(event);

      trackTransportAccessibilityEntryClick();
    },
    [openTransportAccessibility],
  );

  if (!transportAccessibilityRate) {
    return null;
  }

  const preparedRate = prepareRate(transportAccessibilityRate.rate);

  return (
    <ActionAfterViewObserver callback={trackTransportAccessibilityEntryShown} triggerOnce>
      <TransportAccessibilityEntry rate={preparedRate} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
